import React from 'react';
import Header from './components/Header';
import AnimRoutes from './components/AnimRoutes'
import { BrowserRouter as Router } from 'react-router-dom'; // router
import { motion } from 'framer-motion' // motion
import { UNDER_CONSTRUCTION } from './siteConfig';

const App = () => {
  return (<>
    <Router>
      {!UNDER_CONSTRUCTION && <Header />}
      <AnimRoutes />
    </Router>
  </>
  );
};

export default App;
